import { QueryFunction, useQuery } from '@tanstack/react-query';
import { createAxiosInstance } from 'api/request';
import { QueryHook } from 'utils/hooks/queries/types';

type RequestReturnType = string;

const request: QueryFunction<RequestReturnType> = async ({ signal }) =>
{
  const response = await createAxiosInstance().get('/user/payment/stripe-portal-link', { signal });
  return response.data.url;
};

export const BASE_QUERY_KEY = 'stripePortalSession';

const useStripePortalSessionQuery: QueryHook<RequestReturnType> = () =>
{
  return useQuery({
    queryKey: [BASE_QUERY_KEY],
    queryFn: request,
  });
};

export default useStripePortalSessionQuery;